import { useState, useEffect } from "react";
import React from "react";
import ReactSelect from "react-select";
import axios from "axios";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import Swal from "sweetalert2";
import fileDownload from "js-file-download";
import AsyncSelect from "react-select/async";
import {
  Box,
  Button,
  Typography,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
} from "@mui/material";
import Moment from "moment";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { useAlert } from "react-alert";
import DescriptionIcon from "@mui/icons-material/Description";
import SendIcon from "@mui/icons-material/Send";
import SaveIcon from "@mui/icons-material/Save";

const PreviewClaim = (props) => {
  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = { Authorization: auth };
  const alert = useAlert();

  const [charges, setCharges] = useState("");
  const [createdDate, setcreatedDate] = useState("");
  const [charges1, setCharges1] = useState("");
  const [charges2, setCharges2] = useState("");
  const [charges3, setCharges3] = useState("");
  const [code, setCode] = useState("");
  const [code1, setCode1] = useState("");
  const [code2, setCode2] = useState("");
  const [code3, setCode3] = useState("");
  const [UNIT, setUNIT] = useState("");
  const [UNIT1, setUNIT1] = useState("");
  const [UNIT2, setUNIT2] = useState("");
  const [UNIT3, setUNIT3] = useState("");
  const [ProcedureID, setProcedureID] = useState(0);
  const [ProcedureID1, setProcedureID1] = useState(0);
  const [ProcedureID2, setProcedureID2] = useState(0);
  const [ProcedureID3, setProcedureID3] = useState(0);
  const [d, setD] = useState([]);
  const [d1, setD1] = useState([]);
  const [d2, setD2] = useState([]);
  const [d3, setD3] = useState([]);
  const [dxPointer, setdxPointer] = useState([]);
  const [dxPointer1, setdxPointer1] = useState([]);
  const [dxPointer2, setdxPointer2] = useState([]);
  const [dxPointer3, setdxPointer3] = useState([]);
  const [POS, setPOS] = useState(["", "", "", ""]);
  const [modifiers, setModifiers] = useState([
    ["", "", "", ""],
    ["", "", "", ""],
    ["", "", "", ""],
    ["", "", "", ""],
  ]);
  const [dos, setDos] = useState("");
  const [dos1, setDos1] = useState("");
  const [dos2, setDos2] = useState("");
  const [dos3, setDos3] = useState("");
  const [claimId] = useState(props.claimId);
  const [submitting, setSubmitting] = useState(false);
  const [patientid, setPatientid] = useState(false);
  const [patientInsuranceName, setPatientInsuranceName] = useState("");
  const [patientAddress, setPatientAddress] = useState("");
  const [patientCity, setPatientCity] = useState("");
  const [patientState, setPatientState] = useState("");
  const [patienZip, setPatientZip] = useState("");
  const [patientDOB, setPatientDOB] = useState(Moment().format("YYYY-MM-DD"));
  const [PatientName, setPatientName] = useState("");
  const [memberid, setMemberid] = useState("");
  const [SecondarMemberid, setSecondarMemberid] = useState("");
  const [SecondarInsuranceName, setSecondarInsuranceName] = useState("");
  const [diagnosisList, setDiagnosisList] = useState([]);
  const [procedureCodeList, setProcedureCodeList] = useState([]);
  const [referringPhysicianList, setReferringPhysicianList] = useState([]);
  const [providers, setProviders] = useState([]);
  const [taxId, setTaxId] = useState("");
  const [npi, setNpi] = useState("");
  const [referringProviderNpi, setReferringProviderNpi] = useState("");
  const [providerError, setProviderError] = useState(false);
  const [assignmentError, setAssignmentError] = useState("");
  const [procedureError, setProcedureError] = useState("");
  const [diagnosisError, setDiagnosisError] = useState("");

  // NEW STATES FOR CMS-1500 FORM
  const [patientRelationship, setPatientRelationship] = useState("Self");
  const [insuredName, setInsuredName] = useState("");
  const [insuredAddress, setInsuredAddress] = useState("");
  const [insuredDOB, setInsuredDOB] = useState("");
  const [insuredSex, setInsuredSex] = useState("M");
  const [priorAuthorization, setPriorAuthorization] = useState("");
  const [resubmissionCode, setResubmissionCode] = useState("1");
  const [payerICN, setPayerICN] = useState("");
  const isResubmissionSelected = resubmissionCode === "7" || resubmissionCode === "8";
  const [signatureDate, setSignatureDate] = useState(
    Moment().format("YYYY-MM-DD"),
  );

const getMatchedOption = (rowData) => {
  if (!rowData.procedure) return null;

  return (
    procedureCodeList.find(
      (opt) =>
        String(opt.value) === String(rowData.procedure) &&
        parseFloat(opt.default_charges) === parseFloat(rowData.charges)
    ) || procedureCodeList.find(
      (opt) => String(opt.value) === String(rowData.procedure)
    ) || null
  );
};
useEffect(() => {
  if (!procedureCodeList.length) return;

  const initialPOS = ["", "", "", ""];
  const initialMods = [
    ["", "", "", ""],
    ["", "", "", ""],
    ["", "", "", ""],
    ["", "", "", ""],
  ];

  const rows = [
    { procedure: code, charges },
    { procedure: code1, charges: charges1 },
    { procedure: code2, charges: charges2 },
    { procedure: code3, charges: charges3 },
  ];

  rows.forEach((row, index) => {
    const match = procedureCodeList.find(
      (opt) =>
        opt.value === row.procedure &&
        parseFloat(opt.qasim) === parseFloat(row.charges)
    );

    if (match) {
      initialPOS[index] = match.placeOfService || "";

      initialMods[index] = [
        match.modifiers1 || "",
        match.modifiers2 || "",
        match.modifiers3 || "",
        match.modifiers4 || "",
      ];
    }
  });

  setPOS(initialPOS);
  setModifiers(initialMods);
}, [procedureCodeList, code, code1, code2, code3]);
  const [serviceFacilityInfo, setServiceFacilityInfo] = useState("");
  const [billingProvider, setbillingProvider] = useState(null);
  const [ProviderState, setProviderState] = useState("");
  const [ProviderZip, setProviderZip] = useState("");
  const [Providerphone, setProviderphone] = useState("");
  const [ProviderAddress, setProviderAddress] = useState("");
  const [totalCharge, setTotalCharge] = useState("0.00");
  const [amountPaid, setAmountPaid] = useState("0.00");
  const [balanceDue, setBalanceDue] = useState("0.00");
  const [insuranceType, setInsuranceType] = useState({
    medicare: false,
    medicaid: false,
    tricare: false,
    champva: false,
    groupHealthPlan: false,
    feca: false,
    other: false,
  });
  const [diagnosisCodes, setDiagnosisCodes] = useState({});

  // Form Configuration
  const validationSchema = Yup.object({
    dos: Yup.string().required("DOS is required"),
    patientName: Yup.string().required("Patient is required"),
  });
  const defValues = {
    id: 0,
    patientId: 0,
    billingProvider: 0,
    attendingPhysician: 0,
    insuranceName: "",
    memberId: 0,
    referringPhysician: 0,
    practiceId: "",
    patientName: "",
    patientName: "",
    dos: "",
    dos1: "",
    dos2: "",
    pos: "",
    frontnote: "",
    amountDue: 0,
    discount: 0,
    writeOff: 0,
    claimTotal: 0,
    amountPaid: 0,
    amountAllowed: 0,
    totalCharges: 0,
    adjustments: 0,
    backnote: "",
    referringPhysicianName: "",
    referringPhysicianId: 0,
    renderingProvider: "",
    cpt1: "",
    cpt2: "",
    cpt3: "",
    charges1: "",
    charges2: "",
    charges3: "",
    authNumber: "",
    acceptAssignment: "",
    dontAcceptAssignment: "",
    // defaultTwoweek: "",
    // FollowUp5Days: "",
    // FollowUp10Days: "",
    followUpTime: "14",
    secondaryPending: "",
    additionalInformation: "",
    submitted: false,
    payment: false,
    Carries: "",
    referringProvider: "",
    createdDate: "",
    updatedDate: "",
    compeleted: false,
    statusType: "Pending",
    diagnosis: {
      id: 0,
      claimId: 0,
      diagSequence: 0,
      description: "",
      code: "",
      dx1: "",
      dx2: "",
      dx3: "",
      dx4: "",
      dx5: "",
      dx6: "",
      dx7: "",
      dx8: "",
      dx9: "",
      dx10: "",
      dx11: "",
      dx12: "",
      patientId: 0,
    },
  };
  const {
    register,
    control,
    handleSubmit,
    setValue,
    watch,
    getValues,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onChange",
    resolver: yupResolver(validationSchema),
    defaultValues: defValues,
  });

  const attendingPhysician = watch("attendingPhysician");
  const referringPhysician = watch("referringPhysician");
  const practiceID = localStorage.getItem("default_paractice");
  const User_Type = localStorage.getItem("User_Type");
  const claimPracticeID = props.claimPracticeID;
  const PatientidOfClaim = props.PatientidOfClaim;
  const Label = ({ text }) => (
    <div style={{ fontSize: 11, fontWeight: "bold", marginBottom: 3 }}>
      {text}
    </div>
  );

  const selectStyle = {
    width: "100%",
    border: "1px solid #999",
    padding: "2px",
    fontSize: 11,
    height: 24,
  };

  const cellStyle = {
    border: "1px solid #000",
    padding: "5px",
    verticalAlign: "top",
  };
  // Calculate total charges
  useEffect(() => {
    const total =
      (parseFloat(charges) || 0) +
      (parseFloat(charges1) || 0) +
      (parseFloat(charges2) || 0) +
      (parseFloat(charges3) || 0);
    setTotalCharge(total.toFixed(2));
    setBalanceDue((total - (parseFloat(amountPaid) || 0)).toFixed(2));
  }, [charges, charges1, charges2, charges3, amountPaid]);
  const acceptAssignment = watch("acceptAssignment");
  const dontAcceptAssignment = watch("dontAcceptAssignment");
  const [priInsuranceId, setpriInsuranceId] = useState("");
  const [secInsuranceId, setsecInsuranceId] = useState("");
  useEffect(() => {
    if (patientid > 0) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/Patients/SearchInsuranceName?patientId=${patientid}`,
          { headers },
        )
        .then((response) => {
          const Data = response[0] || {};
          const fullAddress = [
            Data.address,
            Data.city,
            Data.state,
            Data.zipCode,
          ]
            .filter(Boolean)
            .join(", ");

          const primary = response.find(
            (r) => r.type?.toLowerCase() === "primary",
          );
          const secondary = response.find(
            (r) => r.type?.toLowerCase() === "secondary",
          );

          setPatientInsuranceName(primary?.planName || "");
          setPatientAddress(fullAddress);
          setPatientDOB(Moment(Data.dob).format("YYYY-MM-DD"));
          setMemberid(primary?.memberId || "");
          setPriPayerId(primary?.payerId);
          setSecPayerId(secondary?.payerId);
          setPatientName(Data.patientName || "");
          setpriInsuranceId(primary?.id);
          setInsuredName(Data.patientName || "");
          setPatientZip(Data?.zipCode);
          setPatientCity(Data?.city);
          setPatientState(Data?.state);
          setInsuredAddress(fullAddress);
          setInsuredDOB(Moment(Data.dob).format("YYYY-MM-DD"));
          setSecondarInsuranceName(secondary?.planName || "");
          setsecInsuranceId(secondary?.id);
          setSecondarMemberid(secondary?.memberId || "");

          // Set default values
          setValue("patientName", Data.patientName || "");
          setValue("insuranceName", primary?.planName || "");
        })
        .catch((error) => {
          console.error("Error loading patient data:", error);
        });
    }
  }, [patientid]);
  const [diagnosisLoaded, setDiagnosisLoaded] = useState(false);
// Keep track of selected option per row index
const [selectedProcedureRows, setSelectedProcedureRows] = useState({});
  useEffect(() => {
    // Fetch diagnosis list
    axios
      .get(`${process.env.REACT_APP_API_URL}/Diagnosis/Diagnosis`, { headers })
      .then((response) => {
        const diagnosisOptions = response.map((field) => ({
          
          label: field.code,
          value: field.id,
        }));
        setDiagnosisList(diagnosisOptions);
        setDiagnosisLoaded(true);
      })
      .catch(console.error);

    // Fetch procedure codes
axios
  .get(`${process.env.REACT_APP_API_URL}/Procedures/Procedures`, {
    headers,
  })
  .then((response) => {
    const procedureOptions = response.map((field) => {
      // Split description into words
      const words = field.description ? field.description.split(" ") : [];
      // Take only first 12 words
      const shortDescription = words.length > 3 
        ? words.slice(0, 3).join(" ") + "..." 
        : field.description;

      return {
        label: `${field.code} - ${shortDescription}`,
        value: field.code,
        qasim: field.default_charges,
        default_charges: parseFloat(field.default_charges), 
        unit: field.unit,
        description: field.description,  // full description if needed elsewhere
        placeOfService: field.placeOfService,
        modifiers1: field.modifiers1,
        modifiers2: field.modifiers2,
        modifiers3: field.modifiers3,
        modifiers4: field.modifiers4,
        fullRow: field    
      };
    });
    setProcedureCodeList(procedureOptions);
      })
      .catch(console.error);
  }, []);
  const getLabel = (id) => {
    const found = diagnosisList.find(
      (item) => String(item.value) === String(id),
    );
    return found ? found.label : id;
  };
  // Load claim data
  useEffect(() => {
    if (claimId > 0) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/claims/ClaimsById?claimId=${claimId}`,
          { headers },
        )
        .then((response) => {
          const claimData = response;
          // Set basic form values
          Object.keys(claimData).forEach((key) => {
            if (key in getValues()) {
              setValue(key, claimData[key]);
            }
          });
          setValue("acceptAssignment", claimData.acceptAssignment);
          setValue("dontAcceptAssignment", claimData.dontAcceptAssignment);
          setValue("referringPhysician", claimData.referringPhysician);
          setPatientid(claimData.patientId);
          setPriorAuthorization(claimData.authNumber);
          // Format DOS
          const dateto342 = Moment(claimData.dos).format("YYYY-MM-DD");
          setDos(dateto342);
          const datetoaw = Moment(claimData.createdDate).format("YYYY-MM-DD");
          setcreatedDate(datetoaw);

          // Load procedures
          const procedures = claimData.procedures || [];

          if (procedures[0]) {
            setCharges(procedures[0].charges || "");
            setCode(procedures[0].code || "");
            setUNIT(procedures[0].units || "");

            setD(
              procedures[0].dxPointer1
                ?.split(",")
                .map((code) => code.trim())
                .filter(Boolean) || [],
            );
            setdxPointer(
              procedures[0].dxPointer1
                ?.split(",")
                .map((code) => code.trim())
                .filter(Boolean) || [],
            );
            const rawDates = procedures[0]?.dosTo;
            const dateto1 = Moment(rawDates, Moment.ISO_8601, true).isValid()
              ? Moment(rawDates).format("YYYY-MM-DD")
              : "";
            setDos(dateto1);
            setProcedureID(procedures[0].id || 0);
            setValue("cpt1", procedures[0].code || "");
          }
          if (procedures[1]) {
            setCharges1(procedures[1].charges || "");
            setCode1(procedures[1].code || "");
            setUNIT1(procedures[1].units || "");

            setD1(
              procedures[1].dxPointer1
                ?.split(",")
                .map((code) => code.trim())
                .filter(Boolean) || [],
            );
            const rawDates = procedures[1]?.dosTo;
            const dateto2 = Moment(rawDates, Moment.ISO_8601, true).isValid()
              ? Moment(rawDates).format("YYYY-MM-DD")
              : "";
            setDos1(dateto2);
            setProcedureID1(procedures[1].id || 0);
            setValue("cpt2", procedures[1].code || "");
            setdxPointer1(
              procedures[1].dxPointer1
                ?.split(",")
                .map((code) => code.trim())
                .filter(Boolean) || [],
            );
          }
          if (procedures[2]) {
            setCharges2(procedures[2].charges || "");
            setCode2(procedures[2].code || "");
            setUNIT2(procedures[2].units || "");
            setD2(
              procedures[2].dxPointer1
                ?.split(",")
                .map((code) => code.trim())
                .filter(Boolean) || [],
            );
            const rawDates = procedures[2]?.dosTo;
            const dateto342123 = Moment(
              rawDates,
              Moment.ISO_8601,
              true,
            ).isValid()
              ? Moment(rawDates).format("YYYY-MM-DD")
              : "";
            setDos2(dateto342123);
            setProcedureID2(procedures[2].id || 0);
            setValue("cpt3", procedures[2].code || "");
            setdxPointer2(
              procedures[2].dxPointer1
                ?.split(",")
                .map((code) => code.trim())
                .filter(Boolean) || [],
            );
          }
          if (procedures[3]) {
            setCharges3(procedures[3].charges || "");
            setCode3(procedures[3].code || "");
            setUNIT3(procedures[3].units || "");

            setD3(
              procedures[3].dxPointer1
                ?.split(",")
                .map((code) => code.trim())
                .filter(Boolean) || [],
            );
            const rawDates = procedures[3]?.dosTo;
            const dateto342123 = Moment(
              rawDates,
              Moment.ISO_8601,
              true,
            ).isValid()
              ? Moment(rawDates).format("YYYY-MM-DD")
              : "";
            setDos3(dateto342123);
            setProcedureID3(procedures[3].id || 0);
            setValue("cpt3", procedures[3].code || "");
            setdxPointer3(
              procedures[3].dxPointer1
                ?.split(",")
                .map((code) => code.trim())
                .filter(Boolean) || [],
            );
          }
          if (procedures.length > 0) {
            const tempDiagnosisCodes = {
              A: "",
              B: "",
              C: "",
              D: "",
              E: "",
              F: "",
              G: "",
              H: "",
              I: "",
              J: "",
              K: "",
              L: "",
            };

            procedures.forEach((proc, index) => {
              const dxArray = proc.dxPointer1
                ?.split(",")
                .map((code) => code.trim())
                .filter(Boolean);

              if (dxArray) {
                dxArray.forEach((code, i) => {
                  const letter = String.fromCharCode(65 + i + index * 1); // A–L sequential
                  if (letter <= "L")
                    tempDiagnosisCodes[letter] = getLabel(code);
                });
              }
            });

            setDiagnosisCodes(tempDiagnosisCodes);
          }

          // Load total charges
          if (claimData.totalCharges) {
            setTotalCharge(parseFloat(claimData.totalCharges).toFixed(2));
          }
          if (claimData.amountPaid) {
            setAmountPaid(parseFloat(claimData.amountPaid).toFixed(2));
          }
          if (claimData.amountDue) {
            setBalanceDue(parseFloat(claimData.amountDue).toFixed(2));
          }
        })
        .catch((error) => {
          console.error("Error loading claim:", error);
        });
    }
  }, [claimId, diagnosisLoaded]);

  useEffect(() => {
    const endpoint =
      !claimPracticeID || claimPracticeID === practiceID
        ? `${process.env.REACT_APP_API_URL}/ReferringPhysicians/ReferringPhysicians?parcticeid=${practiceID}`
        : `${process.env.REACT_APP_API_URL}/ReferringPhysicians/ReferringPhysicians?patientid=${PatientidOfClaim}`;

    axios
      .get(endpoint, { headers })
      .then((response) => {
        const referringOptions = response.map((field) => ({
          label: `${field.lastName}, ${field.firstName} (NPI: ${field.npi})`,
          value: field.id,
          npi: field.npi,
          lastName: field.lastName,
          firstName: field.firstName,
        }));
        setReferringPhysicianList(referringOptions);
      })
      .catch(console.error);
  }, [practiceID, PatientidOfClaim, claimPracticeID]);
  const [SearchInsurance, setSearchInsurance] = useState([]);

  // useEffect(() => {
  //   axios
  //     .get(`${process.env.REACT_APP_API_URL}/Insurances/getInsuranceByName`, {
  //       headers,
  //     })
  //     .then((response) => {
  //       const InsuranceOptions = response.map((field) => ({
  //         label: field.name,
  //         value: field.id,
  //         payerId: field.payerid,
  //       }));
  //       setSearchInsurance(InsuranceOptions);
  //     })
  //     .catch(console.error);
  // }, []);
  const [selectedInsurance, setSelectedInsurance] = useState(null);
  const [selectedSecInsurance, setselectedSecInsurance] = useState(null);

  const loadInsuranceOptions = async (inputValue) => {
    if (!inputValue) return []; // no search, return empty array

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/Insurances/getInsuranceByName?Name=${inputValue}`,
        { headers },
      );

      // full options for AsyncSelect
      const asyncOptions = response.map((field) => ({
        label: `${field.name} (Payer ID: ${field.payerid})`,
        value: field.id,
        payerId: field.payerid,
      }));

      // simpler options for your local state if needed
      const simpleOptions = response.map((field) => ({
        label: `${field.name} (Payer ID: ${field.payerid})`,
        value: field.id,
        payerId: field.payerid,
      }));
      setSearchInsurance(simpleOptions);

      return asyncOptions;
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  // Load providers
  useEffect(() => {
    const endpoint =
      !claimPracticeID || claimPracticeID === practiceID
        ? `${process.env.REACT_APP_API_URL}/Providers/getPracticeProvider?parcticeid=${practiceID}`
        : `${process.env.REACT_APP_API_URL}/Providers/getPracticeProvider?patientid=${PatientidOfClaim}`;

    axios
      .get(endpoint, { headers })
      .then((response) => {
        const providerOptions = response.map((field) => ({
          label: field.name || `${field.lastName}, ${field.firstName}`,
      //       label:
      // PatientidOfClaim
      //   ? `${field.firstName}, ${field.lastName}`  
      //   : field.name, 
          value: field.id,
          npi: field.npi || field.nPI,
          taxId: field.taxId,
          billingProvider: field.isbillingProvider || field.billingPhysician,
      //      billingProvider:
      // PatientidOfClaim
      //   ? field.billingPhysician   // 👈 jab patientid ho
      //   : field.isbillingProvider, 
          address: field.address,
          zipCode: field.zipCode,
          state: field.state,
          phone: field.phoneNo,
        }));
        setProviders(providerOptions);
      })
      .catch(console.error);
  }, [practiceID, claimPracticeID, PatientidOfClaim]);

  // Set provider NPI and Tax ID when attending physician changes
  useEffect(() => {
    if (attendingPhysician && providers.length > 0) {
      const selectedProvider = providers.find(
        (option) => option.value === attendingPhysician,
      );
      if (selectedProvider) {
        setNpi(selectedProvider.npi || "");
        setTaxId(selectedProvider.taxId || "");
        setbillingProvider(selectedProvider.billingProvider);
        setProviderAddress(selectedProvider.address);
        setProviderphone(selectedProvider.phone);
        setProviderZip(selectedProvider.zipCode);
        setProviderState(selectedProvider.state);
      }
    }
  }, [attendingPhysician, providers]);

  // Set referring provider NPI
  useEffect(() => {
    if (referringPhysician && referringPhysicianList.length > 0) {
      const selected = referringPhysicianList.find(
        (p) => String(p.value) === String(referringPhysician),
      );
      if (selected) {
        setReferringProviderNpi(selected.npi || "");
      }
    }
  }, [referringPhysicianList, referringPhysician]);

  const handleDiagnosisCodeChange = (letter, value) => {
    setDiagnosisCodes((prev) => ({
      ...prev,
      [letter]: value,
    }));
  };

  const InputStyle = {
    width: "100%",
    border: "1px solid #999",
    padding: "3px",
    fontSize: 11,
    height: 24,
    boxSizing: "border-box",
  };

  const simpleSelectStyle = {
    control: (base) => ({
      ...base,
      minHeight: "24px",
      height: "30px",
      borderRadius: "2px",
      border: "1px solid #999",
      boxShadow: "none",
      backgroundColor: "#fff",
      padding: "0 2px 0 5px",
      width: "100%",
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0 4px",
      height: "24px",
      minHeight: "24px",
      display: "flex",
      flexWrap: "wrap",
      overflow: "hidden",
      gap: "2px",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "11px",
      lineHeight: "24px",
      color: "#000",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "11px",
      lineHeight: "24px",
      color: "#000",
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#dcdcdc",
      borderRadius: "2px",
      padding: "0 2px",
      margin: "0 2px 0 0",
      height: "18px",
      display: "flex",
      alignItems: "center",
    }),
    multiValueLabel: (base) => ({
      ...base,
      fontSize: "9px",
      padding: "0 2px",
      lineHeight: "16px",
    }),
    multiValueRemove: (base) => ({
      ...base,
      fontSize: "10px",
      padding: "0 2px",
      cursor: "pointer",
      color: "#555",
      "&:hover": {
        backgroundColor: "#aaa",
        color: "#fff",
      },
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
      fontSize: "11px",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    menu: (base) => ({
      ...base,
      fontSize: "11px",
      zIndex: 9999,
    }),
    option: (base, state) => ({
      ...base,
      fontSize: "11px",
      color: "#000",
      backgroundColor: state.isFocused ? "#f0f0f0" : "#fff",
      padding: "4px 8px",
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };
  const tinySelectStyle = {
    control: (base) => ({
      ...base,
      minHeight: "30px",
      height: "30px",
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0 4px",
      height: "30px",
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "30px",
    }),

    /* 🔥 OPTIONS Z-INDEX */
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };

  const [PriPayerId, setPriPayerId] = useState("");
  const [SecPayerId, setSecPayerId] = useState("");
  const [SecRelation, setSecRelation] = useState("");
  const [PriRelation, setPriRelation] = useState("");
  const [PatientSex, setPatientSex] = useState("");

  useEffect(() => {
    if (patientid > 0) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/Patients/getPatientById?id=${
            patientid !== undefined ? patientid : 0
          }`,
          { headers },
        )
        .then((response) => {
          // setPriPayerId(response?.priIns?.payerId);
          // setSecPayerId(response?.secIns?.payerId);
          setPatientSex(response?.gender);
          setPriRelation(response?.priIns?.subsRelation);
          setSecRelation(response?.secIns?.subsRelation);
        })
        .catch((error) => {});
    }
  }, [patientid]);
  const [PracticeName, setPracticeName] = useState("");
  const [facilityId, setfacilityId] = useState(practiceID);
  const [PracticeAddress, setPracticeAddress] = useState("");
  const [PracticeNPI, setPracticeNPI] = useState("");
  const [PracticeZipcode, setPracticeZipcode] = useState({
    city: "",
    state: "",
    zipCode: "",
  });
  useEffect(() => {
    if (facilityId > 0) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/Practices/getPracticeById?id=${
            facilityId !== undefined ? facilityId : facilityId
          }`,
          { headers },
        )
        .then((response) => {
          // setPracticeName(response.practiceName);
          setPracticeAddress(response.address);
          setPracticeNPI(response.npi)
          setPracticeZipcode({
            city: response.city || "",
            state: response.state || "",
            zipCode: response.zipCode || "",
          });
        })
        .catch((error) => {});
    }
  }, [practiceID,facilityId]);


    const [Practices, setPractices] = useState(null);
    const Emailaddress = localStorage.getItem("Emailaddress");
  
    useEffect(() => {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/UserPractices/getUserPractices?userEmail=${Emailaddress}`,
          {
           headers
          }
        )
        .then((response) => {
          const bprov = response.map((field) => ({
            label: field.practiceName,
            value: field.practiceId,
          }));
          setPractices(bprov);
        })
        .catch((error) => {
          console.error("Error fetching referring physicians:", error);
        });
    }, []);
 
  //   useEffect(() => {
  //   if (patientInsuranceName) {
  //     setSelectedInsurance({
  //       label: patientInsuranceName,
  //       value: priInsuranceId || null,
  //     });
  //   }
  //   if (SecondarInsuranceName) {
  //     setselectedSecInsurance({
  //       label: SecondarInsuranceName,
  //       value: secInsuranceId || null,
  //     });
  //   }
  // }, []);
  const handleSubmitInsurance = async () => {
    try {
      const primaryInsurance = {
        patientId: patientid,
        type: "primary",
        planName: patientInsuranceName,
        payerId: PriPayerId,
        relation: PriRelation,
        memberId: memberid,
        insuranceId: priInsuranceId,
      };

      // 🔹 Prepare Secondary Insurance ONLY if values exist
      let secondaryInsurance = null;
      if (secInsuranceId || SecondarMemberid) {
        secondaryInsurance = {
          patientId: patientid,
          type: "secondary",
          planName: SecondarInsuranceName,
          payerId: SecPayerId,
          relation: SecRelation,
          memberId: SecondarMemberid,
          insuranceId: secInsuranceId,
        };
      }

      // 🔹 Prepare final array for API
      const insurances = [primaryInsurance];
      if (secondaryInsurance) insurances.push(secondaryInsurance);

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/Patients/UpdatePatientInsurance`,
        insurances,
        { headers }, // authentication headers
      );
      // props.CloseModal();
    } catch (error) {
      console.error(error);
    }
  };
  // Submit Handler
  const onSubmit = (data) => {
    let errors = [];

    if (!code) {
      errors.push("At least one procedure code is required.");
    }

    if (d.length === 0) {
      errors.push("At least one diagnosis code is required.");
    }

    if (!attendingPhysician) {
      errors.push("Provider is required.");
    }

    if (!data.acceptAssignment && !data.dontAcceptAssignment) {
      errors.push("Please select assignment option.");
    }
// 🔴 Box 22 Validation
const isResubmissionSelected =
  resubmissionCode === "7" || resubmissionCode === "8";

const hasICN = payerICN && payerICN.trim() !== "";

// ICN required only for Replacement / Void claims
if (isResubmissionSelected && !hasICN) {
  errors.push(
    "Box 22: Payer ICN is required for Replacement or Void claims."
  );
}

// Optional: Prevent ICN entry for Original Claim
if (!isResubmissionSelected && hasICN) {
  errors.push(
    "Box 22: Payer ICN should only be entered for Replacement or Void claims."
  );
}
    const hasPrimaryInsurance =
      patientInsuranceName && patientInsuranceName.trim() !== "";

    const hasSecondaryInsurance =
      SecondarInsuranceName && SecondarInsuranceName.trim() !== "";

    // 🔴 At least one insurance required
    if (!hasPrimaryInsurance && !hasSecondaryInsurance) {
      errors.push(
        "Please first add Primary or Secondary Insurance for this patient.",
      );
    }

    // 🔴 Primary payer id validation
    if (hasPrimaryInsurance) {
      if (!PriPayerId || PriPayerId.trim() === "") {
        errors.push("Primary Insurance Payer ID is empty or invalid.");
      }
    }

    // 🔴 Secondary payer id validation
    if (hasSecondaryInsurance) {
      if (!SecPayerId || SecPayerId.trim() === "") {
        errors.push("Secondary Insurance Payer ID is empty or invalid.");
      }
    }

    if (errors.length > 0) {
      // 🔹 Show errors as styled list
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        html: `
      <ul style="text-align: left; padding-left: 20px; color: #d33; font-size: 14px;">
        ${errors.map((e) => `<li>${e}</li>`).join("")}
      </ul>
    `,
        willOpen: () => {
          const swalPopup = document.querySelector(".swal2-container");
          if (swalPopup) swalPopup.style.zIndex = 2200;
        },
      });
      return;
    }

    // Prepare diagnosis codes for Box 21
    const diagCodes = Object.values(diagnosisCodes).filter(
      (code) => code.trim() !== "",
    );

    // Prepare post data
    const postData = {
      ...data,
      acceptAssignment: data.acceptAssignment === true,
      dontAcceptAssignment: data.dontAcceptAssignment === true,
      authNumber: priorAuthorization,
      medicalResubmisionCode:resubmissionCode,
      icnNumber:payerICN,
      practiceId:claimPracticeID ? claimPracticeID : practiceID,
      Carries: data.insuranceName,
      insuranceName: data.insuranceName,
      patientName: data.patientName,
      patientId: patientid > 0 ? patientid : 0,
      totalCharges: parseFloat(totalCharge),
      amountPaid: parseFloat(amountPaid),
      amountDue: parseFloat(balanceDue),
      attendingPhysician: data.attendingPhysician,
      referringPhysician: data.referringPhysician,
      facilityId:facilityId,
    };

    // Prepare procedures
    const DiagnosisCode = [
      Array.isArray(d) ? d.join(",") : "",
      Array.isArray(d1) ? d1.join(",") : "",
      Array.isArray(d2) ? d2.join(",") : "",
      Array.isArray(d3) ? d3.join(",") : "",
    ];

    const DOS = [dos, dos1, dos2, dos3];
    const ProcedureIDs = [
      ProcedureID,
      ProcedureID1,
      ProcedureID2,
      ProcedureID3,
    ];
    const Code = [code, code1, code2, code3];
    const Charges = [charges, charges1, charges2, charges3];
    const UNits = [UNIT, UNIT1, UNIT2, UNIT3];

    postData.procedures = Code.filter((code, index) => code).map(
      (code, index) => ({
        code,
        charges: Charges[index] || null,
        dosTo: DOS[index] || null,
        dxPointer1: DiagnosisCode[index] || null,
        id: ProcedureIDs[index] || 0,
        claimId: claimId,
        units: UNits[index] || 0,
         pos: POS[index] || "",
        mod1: modifiers[index][0] || "",
        mod2: modifiers[index][1] || "",
        mod3: modifiers[index][2] || "",
        mod4: modifiers[index][3] || "",
      }),
    );

    setSubmitting(true);
    axios
      .post(`${process.env.REACT_APP_API_URL}/claims/addclaims`, postData, {
        headers,
      })
      .then((response) => {
        handleSubmitInsurance();
        setSubmitting(false);
        // props.handleClosePreview();
        // props.CloseModal();
        handleGenerateClaims();
        //   setTimeout(() => {
        //     alert.success("Claim Update successfully.", {
        //       type: "success",
        //     });
        //   }, 500);
        // })
        Swal.fire({
          icon: "success",
          title: "Claim Updated",
          text: "Claim has been successfully updated.",
          timer: 2000, // auto close after 2 seconds
          showConfirmButton: false,
          willOpen: () => {
            const swalPopup = document.querySelector(".swal2-container");
            if (swalPopup) {
              // 🔹 Increase z-index to make sure it's on top of everything
              swalPopup.style.zIndex = 5000;

              // Optional: popup itself slightly higher than container
              const swalContent = swalPopup.querySelector(".swal2-popup");
              if (swalContent) swalContent.style.zIndex = 5001;
            }
          },
        });
      })
      .catch((error) => {
        setSubmitting(false);
        // props.handleClosePreview();
        Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: "Error saving claim. Please try again.",
          timer: 2000, // auto close after 2 seconds
          showConfirmButton: false,
          willOpen: () => {
            const swalPopup = document.querySelector(".swal2-container");
            if (swalPopup) {
              // 🔹 Increase z-index to make sure it's on top of everything
              swalPopup.style.zIndex = 5000;

              // Optional: popup itself slightly higher than container
              const swalContent = swalPopup.querySelector(".swal2-popup");
              if (swalContent) swalContent.style.zIndex = 5001;
            }
          },
        });
      });
  };

  const handleGenerateClaims = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/Batches/generateBatchFromClaimIds`,
        [claimId],
        { headers },
      );

      const data = response;
      await Swal.fire({
        icon: data.success ? "success" : "error",
        title: data.success
          ? "Batch Generated Successfully!"
          : "Batch Generation Failed",
        width: "520px",
        padding: "1.5rem",
        background: "#f9fafb",
        color: "#111",
        html: `
            <div style="text-align: left; font-size: 15px; line-height: 1.6; margin-top: 10px;">
              <div style="background: #ffffff; padding: 12px 15px; border-radius: 10px; border: 1px solid #e5e7eb;">
                <p><b style="color:#374151;">Message:</b> ${data.message}</p>
                <p><b style="color:#374151;">Batch ID:</b> ${
                  data.batchId || "N/A"
                }</p>
                <p><b style="color:#374151;">Total Claims:</b> ${
                  data.totalClaims || "0"
                }</p>
              </div>
    
              ${
                data.success
                  ? `
                  <div style="margin-top: 20px; display:flex; justify-content:center; gap:12px;">
                    <button id="downloadBtn"
                      style="
                        background: #2563eb;
                        color: white;
                        border: none;
                        padding: 10px 18px;
                        border-radius: 8px;
                        cursor: pointer;
                        font-size: 14px;
                        font-weight: 600;
                      "
                    >
                      📥 Download EDI
                    </button>
    
                    <button id="uploadBtn"
                      style="
                        background: #059669;
                        color: white;
                        border: none;
                        padding: 10px 18px;
                        border-radius: 8px;
                        cursor: pointer;
                        font-size: 14px;
                        font-weight: 600;
                      "
                    >
                      ☁ Upload to Clearing House
                    </button>
                  </div>
                `
                  : ""
              }
            </div>
          `,
        showConfirmButton: false,
        didRender: () => {
          // 💥 Z-INDEX FIX HERE
          const el = document.querySelector(".swal2-container");
          if (el) el.style.zIndex = 2000;

          const downloadBtn = document.getElementById("downloadBtn");
          if (downloadBtn) {
            downloadBtn.addEventListener("click", async () => {
              await handleDownloadEdiFile(data.ediFilePath);
            });
          }

          const uploadBtn = document.getElementById("uploadBtn");
          if (uploadBtn) {
            uploadBtn.addEventListener("click", async () => {
              uploadClaims(data.ediFilePath);
            });
          }
        },
      });
    } catch (error) {
      console.error("There was an error!", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while generating the batch. Please try again.",
        didRender: () => {
          const el = document.querySelector(".swal2-container");
          if (el) el.style.zIndex = 2000;
        },
      });
    } finally {
    }
  };

const uploadClaims = async (filePath) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/Batches/uploadBatchFile?batchURL=${filePath}`,
      {},
      { headers, responseType: "text" }
    );

    const xmlString = response;
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlString, "text/xml");

    const claimNode = xmlDoc.querySelector("result > claim");

    // ---------------- SUCCESS CASE (ACK) ----------------
    const ackNode = claimNode?.querySelector('messages[mesgid="ACK"]');

    if (ackNode) {
      Swal.fire({
        icon: "success",
        title: "Upload Successful",
        html: `
          <b>Claims uploaded successfully!</b><br/><br/>
          ClaimMD Response: <span style="color:green">ACK - Acknowledged</span>
        `,
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: false,
        didRender: () => {
          const el = document.querySelector(".swal2-container");
          if (el) el.style.zIndex = 2000;
        },
      });
      return;
    }

    // ---------------- VALIDATION ERRORS (UL Compact View) ----------------
    const messageNodes = claimNode?.querySelectorAll("messages");

    if (messageNodes && messageNodes.length > 0) {
      let errorHtml = `
        <div style="text-align:left; max-height:300px; overflow-y:auto;">
          <b>ClaimMD Validation Failed</b><br/><br/>
          <ul style="padding-left:18px; margin:0;">
      `;

      messageNodes.forEach((node) => {
        const mesgid = node.getAttribute("mesgid");
        const message = node.getAttribute("message");
        const field = node.getAttribute("fields");

        errorHtml += `
          <li style="margin-bottom:6px;">
            <span style="color:red;">${message || "Validation error"}</span>
            <br/>
            <small>Field: ${field || "-"} | Code: ${mesgid || "-"}</small>
          </li>
        `;
      });

      errorHtml += `
          </ul>
        </div>
      `;

      Swal.fire({
        icon: "warning",
        title: "Validation Error",
        html: errorHtml,
        width: 600,
        didRender: () => {
          const el = document.querySelector(".swal2-container");
          if (el) el.style.zIndex = 2000;
        },
      });

      return;
    }

    // ---------------- ERROR NODE <error> ----------------
    const errorNode = xmlDoc.querySelector("result > error");

    if (errorNode) {
      const errorMesg =
        errorNode.getAttribute("error_mesg") || "Unknown error";

      Swal.fire({
        icon: "error",
        title: "Upload Failed",
        html: `
          <div style="text-align:left;">
            <b>ClaimMD Error:</b><br/><br/>
            ${errorMesg}
          </div>
        `,
        didRender: () => {
          const el = document.querySelector(".swal2-container");
          if (el) el.style.zIndex = 2000;
        },
      });

      return;
    }

    // ---------------- UNKNOWN RESPONSE ----------------
    Swal.fire({
      icon: "warning",
      title: "Unexpected Response",
      html: `
        ClaimMD returned an unrecognized format.<br/><br/>
        <div style="max-height:250px; overflow:auto; text-align:left;">
          <pre style="background:#f3f4f6;padding:10px;border-radius:5px;">
${xmlString}
          </pre>
        </div>
      `,
      width: 650,
      didRender: () => {
        const el = document.querySelector(".swal2-container");
        if (el) el.style.zIndex = 2000;
      },
    });

  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Upload Error",
      text: "Upload failed: " + error.message,
      didRender: () => {
        const el = document.querySelector(".swal2-container");
        if (el) el.style.zIndex = 2000;
      },
    });

  }
};

  const handleDownloadEdiFile = async (filePath) => {
    try {
      const encodedPath = encodeURIComponent(filePath);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/PatientDocument/DownloadAWSFile?path=${encodedPath}`,
        {
          headers,
          responseType: "blob",
        },
      );

      const filename = filePath.split("/").pop() || `Batch_${Date.now()}.txt`;
      fileDownload(response, filename);

      Swal.fire({
        icon: "success",
        title: "Download Complete",
        text: `EDI file "${filename}" downloaded successfully!`,
        timer: 3000, // Auto-close after 3 seconds
        timerProgressBar: true,
        showConfirmButton: false,
        didRender: () => {
          const el = document.querySelector(".swal2-container");
          if (el) el.style.zIndex = 2000;
        },
      });
    } catch (error) {
      console.error("Error downloading EDI file:", error);
      Swal.fire({
        icon: "error",
        title: "Download Failed",
        text: "Could not download the EDI file.",
        didRender: () => {
          const el = document.querySelector(".swal2-container");
          if (el) el.style.zIndex = 2000;
        },
      });
    }
  };
  const SimpleSubmit = (data) => {
    let errors = [];

    if (!code) {
      errors.push("At least one procedure code is required.");
    }

    if (d.length === 0) {
      errors.push("At least one diagnosis code is required.");
    }

    if (!attendingPhysician) {
      errors.push("Provider is required.");
    }

    if (!data.acceptAssignment && !data.dontAcceptAssignment) {
      errors.push("Please select assignment option.");
    }
  // 🔴 Box 22 Validation
const isResubmissionSelected =
  resubmissionCode === "7" || resubmissionCode === "8";

const hasICN = payerICN && payerICN.trim() !== "";

// ICN required only for Replacement / Void claims
if (isResubmissionSelected && !hasICN) {
  errors.push(
    "Box 22: Payer ICN is required for Replacement or Void claims."
  );
}

// Optional: Prevent ICN entry for Original Claim
if (!isResubmissionSelected && hasICN) {
  errors.push(
    "Box 22: Payer ICN should only be entered for Replacement or Void claims."
  );
}
    const hasPrimaryInsurance =
      patientInsuranceName && patientInsuranceName.trim() !== "";

    const hasSecondaryInsurance =
      SecondarInsuranceName && SecondarInsuranceName.trim() !== "";

    // 🔴 At least one insurance required
    if (!hasPrimaryInsurance && !hasSecondaryInsurance) {
      errors.push(
        "Please first add Primary or Secondary Insurance for this patient.",
      );
    }

    // 🔴 Primary payer id validation
    if (hasPrimaryInsurance) {
      if (!PriPayerId || PriPayerId.trim() === "") {
        errors.push("Primary Insurance Payer ID is empty or invalid.");
      }
    }

    // 🔴 Secondary payer id validation
    if (hasSecondaryInsurance) {
      if (!SecPayerId || SecPayerId.trim() === "") {
        errors.push("Secondary Insurance Payer ID is empty or invalid.");
      }
    }

    if (errors.length > 0) {
      // 🔹 Show errors as styled list
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        html: `
      <ul style="text-align: left; padding-left: 20px; color: #d33; font-size: 14px;">
        ${errors.map((e) => `<li>${e}</li>`).join("")}
      </ul>
    `,
        willOpen: () => {
          const swalPopup = document.querySelector(".swal2-container");
          if (swalPopup) swalPopup.style.zIndex = 2200;
        },
      });
      return;
    }

    // Prepare diagnosis codes for Box 21
    const diagCodes = Object.values(diagnosisCodes).filter(
      (code) => code.trim() !== "",
    );

    // Prepare post data
    const postData = {
      ...data,
      acceptAssignment: data.acceptAssignment === true,
      dontAcceptAssignment: data.dontAcceptAssignment === true,
      authNumber: priorAuthorization,
      medicalResubmisionCode:resubmissionCode,
      icnNumber:payerICN,
      practiceId:claimPracticeID ? claimPracticeID : practiceID,
      Carries: data.insuranceName,
      insuranceName: data.insuranceName,
      patientName: data.patientName,
      patientId: patientid > 0 ? patientid : 0,
      totalCharges: parseFloat(totalCharge),
      amountPaid: parseFloat(amountPaid),
      amountDue: parseFloat(balanceDue),
      attendingPhysician: data.attendingPhysician,
      referringPhysician: data.referringPhysician,
      facilityId:facilityId,

    };

    // Prepare procedures
    const DiagnosisCode = [
      Array.isArray(d) ? d.join(",") : "",
      Array.isArray(d1) ? d1.join(",") : "",
      Array.isArray(d2) ? d2.join(",") : "",
      Array.isArray(d3) ? d3.join(",") : "",
    ];

    const DOS = [dos, dos1, dos2, dos3];
    const ProcedureIDs = [
      ProcedureID,
      ProcedureID1,
      ProcedureID2,
      ProcedureID3,
    ];
    const Code = [code, code1, code2, code3];
    const Charges = [charges, charges1, charges2, charges3];
    const UNits = [UNIT, UNIT1, UNIT2, UNIT3];

    postData.procedures = Code.filter((code, index) => code).map(
      (code, index) => ({
        code,
        charges: Charges[index] || null,
        dosTo: DOS[index] || null,
        dxPointer1: DiagnosisCode[index] || null,
        id: ProcedureIDs[index] || 0,
        claimId: claimId,
        units: UNits[index] || 0,
           pos: POS[index] || "",
        mod1: modifiers[index][0] || "",
        mod2: modifiers[index][1] || "",
        mod3: modifiers[index][2] || "",
        mod4: modifiers[index][3] || "",
      }),
    );

    setSubmitting(true);
    axios
      .post(`${process.env.REACT_APP_API_URL}/claims/addclaims`, postData, {
        headers,
      })
      .then((response) => {
        handleSubmitInsurance();
        setSubmitting(false);
        Swal.fire({
          icon: "success",
          title: "Claim Updated",
          text: "Claim has been successfully updated.",
          timer: 2000, // auto close after 2 seconds
          showConfirmButton: false,
          willOpen: () => {
            const swalPopup = document.querySelector(".swal2-container");
            if (swalPopup) {
              // 🔹 Increase z-index to make sure it's on top of everything
              swalPopup.style.zIndex = 5000;

              // Optional: popup itself slightly higher than container
              const swalContent = swalPopup.querySelector(".swal2-popup");
              if (swalContent) swalContent.style.zIndex = 5001;
            }
          },
        });
      })
      .catch((error) => {
        setSubmitting(false);
        Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: "Error saving claim. Please try again.",
          timer: 2000, // auto close after 2 seconds
          showConfirmButton: true,
          willOpen: () => {
            const swalPopup = document.querySelector(".swal2-container");
            if (swalPopup) {
              // 🔹 Increase z-index to make sure it's on top of everything
              swalPopup.style.zIndex = 5000;

              // Optional: popup itself slightly higher than container
              const swalContent = swalPopup.querySelector(".swal2-popup");
              if (swalContent) swalContent.style.zIndex = 5001;
            }
          },
        });
      });
  };
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px 16px",
          backgroundColor: "#1976d2", // blue header
          color: "#fff",
          borderTopLeftRadius: 6,
          borderTopRightRadius: 6,
          boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
        }}
      >
        {/* Left: Icon + Label */}
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <DescriptionIcon style={{ fontSize: 24 }} />
          <Typography
            variant="h6"
            component="span"
            style={{ fontWeight: "bold" }}
          >
            Claim Submission Form
          </Typography>
        </div>

        {/* Right: Close Icon */}
        <IconButton
          size="small"
          onClick={props.handleClosePreview}
          sx={{
            color: "#fff",
            backgroundColor: "rgba(255,255,255,0.1)",
            "&:hover": { backgroundColor: "rgba(255,255,255,0.2)" },
          }}
        >
          <CancelOutlinedIcon />
        </IconButton>
      </div>
      <TableContainer>
        <Table
          sx={{
            borderCollapse: "collapse",
            border: "1px solid #000",
            tableLayout: "fixed",
          }}
        >
          <TableBody>
            {/* ================= ROW 1 ================= */}
            <TableRow>
              <TableCell colSpan={2} sx={cellStyle}>
                <div style={{ display: "flex", gap: 6 }}>
                  <div style={{ flex: 4 }}>
                    <Label text="1. PAYER NAME" />
                    {/* <input
                      style={InputStyle}
                      value={patientInsuranceName}
                      onChange={(e) => {
                        setPatientInsuranceName(e.target.value);
                        setValue("Carries", e.target.value);
                        setValue("insuranceName", e.target.value);
                      }}
                    /> */}
                    {/* <ReactSelect
                      value={SearchInsurance?.find(
                        (opt) => opt.label === patientInsuranceName
                      )}
                      placeholder="Search And Select"
                      onChange={(selectedOption) => {
                        setPatientInsuranceName(selectedOption.label);
                        setValue("Carries", selectedOption.label);
                        setValue("insuranceName", selectedOption.label);
                        setPriPayerId(selectedOption.payerId);
                        setpriInsuranceId(selectedOption.value);
                      }}
                      isSearchable
                      options={SearchInsurance}
                      styles={simpleSelectStyle}
                      menuPortalTarget={document.body}
                    /> */}
                    <AsyncSelect
                      cacheOptions
                      defaultOptions
                      loadOptions={loadInsuranceOptions}
                      // value={selectedInsurance || patientInsuranceName}
                      value={
                        selectedInsurance
                          ? selectedInsurance
                          : patientInsuranceName
                            ? {
                                label: patientInsuranceName,
                                value: priInsuranceId || "",
                              }
                            : null
                      }
                      // value={patientInsuranceName}
                      placeholder="Search And Select"
                      onChange={(selectedOption) => {
                        setSelectedInsurance(selectedOption);
                        if (selectedOption) {
                          const nameOnly =
                            selectedOption.label.split(" (Payer ID:")[0];
                          setPatientInsuranceName(nameOnly);
                          setValue("Carries", nameOnly);
                          setValue("insuranceName", nameOnly);
                          setPriPayerId(selectedOption.payerId);
                          setpriInsuranceId(selectedOption.value);
                        } else {
                          setPatientInsuranceName("");
                          setValue("Carries", "");
                          setValue("insuranceName", "");
                          setPriPayerId("");
                          setpriInsuranceId("");
                        }
                      }}
                      isClearable
                      styles={tinySelectStyle}
                    />
                  </div>

                  <div style={{ flex: 2 }}>
                    <Label text="PAYER ID " />
                    <input
                      style={{
                        border: "1px solid #999",
                        padding: "3px",
                        fontSize: 11,
                        height: 30,
                        width: "100%",
                        boxSizing: "border-box",
                      }}
                      value={PriPayerId ? PriPayerId : ""}
                    />
                  </div>

                  <div style={{ flex: 2 }}>
                    <Label text="Show Payer Address" />
                    <div style={{ display: "flex", gap: 4 }}>
                      <Checkbox size="small" sx={{ padding: 0 }} />
                      <select style={selectStyle}>
                        <option>PRIMARY</option>
                        <option>SECONDARY</option>
                      </select>
                    </div>
                  </div>
                </div>
              </TableCell>

              <TableCell sx={cellStyle}>
                <Label text="1a. INSURED ID NUMBER/MEMBER ID" />
                <input
                  style={InputStyle}
                  value={memberid ? memberid : ""}
                  onChange={(e) => setMemberid(e.target.value)}
                />
              </TableCell>
            </TableRow>

            {/* ================= ROW 2 ================= */}
            <TableRow>
              <TableCell sx={cellStyle}>
                <Label text="2. PATIENT'S NAME (Last, First)" />
                <div style={{ display: "flex", gap: 6 }}>
                  <input style={InputStyle} value={PatientName} />
                  {/* <Input placeholder="First" /> */}
                </div>
              </TableCell>

              <TableCell sx={cellStyle}>
                <Label text="3. PATIENT DOB /SEX" />
                <div style={{ display: "flex", gap: 6 }}>
                  <input style={InputStyle} type="date" value={patientDOB} />
                  <select
                    style={selectStyle}
                    value={PatientSex || ""} // useState value
                    onChange={(e) => setPatientSex(e.target.value)}
                  >
                    <option value="">Select</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
              </TableCell>

              <TableCell sx={cellStyle}>
                <Label text="4. INSURED'S NAME (Last, First)" />
                <div style={{ display: "flex", gap: 6 }}>
                  <input style={InputStyle} value={PatientName} />
                  {/* <Input placeholder="First" /> */}
                </div>
              </TableCell>
            </TableRow>

            {/* ================= ROW 3 ================= */}
            <TableRow>
              <TableCell sx={cellStyle}>
                <Label text="5. PATIENT ADDRESS" />
                <input
                  style={InputStyle}
                  placeholder="Street Address"
                  value={patientAddress ? patientAddress : ""}
                />
              </TableCell>

              <TableCell sx={cellStyle}>
                <Label text="6. PATIENT RELATIONSHIP TO INSURED" />
                <select
                  style={selectStyle}
                  value={PriRelation || ""}
                  onChange={(e) => setPriRelation(e.target.value)}
                >
                  <option value="">Select</option>
                  <option value="Self">Self</option>
                  <option value="Spouse">Spouse</option>
                  <option value="Mother">Mother</option>
                  <option value="Father">Father</option>
                  <option value="Other">Other</option>
                </select>
              </TableCell>

              <TableCell sx={cellStyle}>
                <Label text="7. INSURED ADDRESS" />
                <input
                  style={InputStyle}
                  placeholder="Street Address"
                  value={patientAddress ? patientAddress : ""}
                />
              </TableCell>
            </TableRow>

            {/* ================= ROW 4 ================= */}
            <TableRow>
              <TableCell sx={cellStyle}>
                <Label text=" ADDRESS 2" />
                <input
                  style={InputStyle}
                  value={patientAddress ? "Same as Above" : ""}
                />
              </TableCell>

              <TableCell sx={cellStyle}>
                <Label text="8. MARITAL STATUS" />
                <select style={selectStyle} defaultValue="">
                  <option value="" disabled>
                    -- Select --
                  </option>
                  <option value="SINGLE"> SINGLE</option>
                  <option value="MARRIED"> MARRIED</option>
                </select>
              </TableCell>

              <TableCell sx={cellStyle}>
                <Label text=" ADDRESS 2" />
                <input style={InputStyle} value={"Same as Above"} />
              </TableCell>
            </TableRow>

            {/* ================= ROW 5 ================= */}
            <TableRow>
              <TableCell sx={cellStyle}>
                <div style={{ display: "flex", gap: 12 }}>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <Label text=" CITY " />
                    <input
                      style={InputStyle}
                      placeholder="City"
                      value={patientCity ? patientCity : ""}
                    />
                  </div>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <Label text="ST " />
                    <input
                      style={InputStyle}
                      placeholder="ST"
                      value={patientState ? patientState : ""}
                    />
                  </div>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <Label text="ZIP " />
                    <input
                      style={InputStyle}
                      placeholder="ZIP"
                      value={patienZip ? patienZip : ""}
                    />
                  </div>
                </div>
              </TableCell>

              <TableCell sx={cellStyle}>
                <Label text=" EMPLOYMENT STATUS" />
                <select style={selectStyle} defaultValue="">
                  <option value="" disabled>
                    -- Select --
                  </option>
                  <option>EMPLOYED</option>
                  <option>UNEMPLOYED</option>
                </select>
              </TableCell>

              <TableCell sx={cellStyle}>
                <div style={{ display: "flex", gap: 12 }}>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <Label text=" CITY " />
                    <input
                      style={InputStyle}
                      placeholder="City"
                      value={patientCity ? patientCity : ""}
                    />
                  </div>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <Label text="ST " />
                    <input
                      style={InputStyle}
                      placeholder="ST"
                      value={patientState ? patientState : ""}
                    />
                  </div>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <Label text="ZIP " />
                    <input
                      style={InputStyle}
                      placeholder="ZIP"
                      value={patienZip ? patienZip : ""}
                    />
                  </div>
                </div>
              </TableCell>
            </TableRow>

            {/* ================= ROW 6 ================= */}
            <TableRow>
              <TableCell sx={cellStyle}>
                <Label text="9. SECONDARY INSURED (L, F, M)" />
                <input
                  style={InputStyle}
                  value={SecondarInsuranceName ? PatientName : ""}
                />

                <Label text="a.SECONDRY INSURED'S POLICY " />
                <input
                  style={InputStyle}
                  value={SecondarInsuranceName ? SecondarMemberid : ""}
                />

                <Label text="b.SECONDRY INSURED'S DATE OF BIRTH/SEX" />
                <div style={{ display: "flex", gap: 6 }}>
                  <input
                    style={InputStyle}
                    type="date"
                    value={SecondarInsuranceName ? patientDOB : "N/A"}
                  />
                </div>
              </TableCell>

              <TableCell sx={cellStyle}>
                <Label text="10. PATIENT CONDITION RELATED TO" />
                {["EMPLOYMENT", "AUTO ACCIDENT", "OTHER ACCIDENT"].map((t) => (
                  <div key={t} style={{ display: "flex", gap: 6 }}>
                    <span style={{ fontSize: 11, width: 100 }}>{t}</span>
                    <select
                      style={{ ...selectStyle, width: 70 }}
                      defaultValue=""
                    >
                      <option value="NO" disabled>
                        -- Select --
                      </option>
                      <option value="NO">NO</option>
                      <option value="YES">YES</option>
                    </select>
                  </div>
                ))}
              </TableCell>

              <TableCell rowSpan={2} sx={cellStyle}>
                <Label text="11. INSURED POLICY GROUP / MEMBER ID" />
                <input
                  style={InputStyle}
                  value={SecondarInsuranceName ? SecondarMemberid : ""}
                  onChange={(e) => setSecondarMemberid(e.target.value)}
                />

                {/* <Label text="11a. DOB" /> */}
                <Label text="a.INSURED'S DATE OF BIRTH/SEX" />
                <div style={{ display: "flex", gap: 6 }}>
                  <input
                    style={InputStyle}
                    type="date"
                    value={patientDOB ? patientDOB : ""}
                  />
                  <select
                    style={selectStyle}
                    value={PatientSex ? PatientSex : ""} // useState value
                    onChange={(e) => setPatientSex(e.target.value)}
                  >
                    <option value="">Select</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>
                  {/* <select style={selectStyle}>
                  <option>MALE</option>
                  <option>FEMALE</option>
                </select> */}
                </div>

                <Label text="b. EMPLOYER'S NAME" />
                <input style={InputStyle} />
                <Label text="c. INSURANCE PLAN NAME" />
                <input
                  style={InputStyle}
                  value={SecondarInsuranceName ? SecondarInsuranceName : ""}
                />
                <Label text="d. IS THERE ANOTHER HEALTH BENEFIT PLAN?" />
                <Box sx={{ display: "flex", gap: 2, alignItems: "center" ,cursor: "not-allowed"}}>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <input
                      type="radio"
                      name="secondaryInsurance"
                      checked={!!SecondarInsuranceName}
                      disabled
                    />
                    <label style={{ fontSize: "11px", margin: "5px" }}>
                      YES
                    </label>
                  </Box>

                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <input
                      type="radio"
                      name="secondaryInsurance"
                      checked={!SecondarInsuranceName}
                      disabled
                    />
                    <label style={{ fontSize: "11px", margin: "5px" }}>
                      NO
                    </label>
                  </Box>

                  <span style={{ fontSize: "11px", color: "#666" }}>
                    <i>if yes, complete item 9, 9a and 9d.</i>
                  </span>
                </Box>
              </TableCell>
            </TableRow>

            {/* ================= ROW 7 ================= */}
            <TableRow>
              <TableCell sx={cellStyle}>
                <Label text="11c. PRIMARY PAYMENT DATE" />
                <input style={InputStyle} type="date" />
              </TableCell>

              <TableCell sx={cellStyle}>
                <Label text="10d. CLAIM CODES" />
                <input style={InputStyle} />

                {/* <Label text="9e. RELATIONSHIP TO PATIENT" /> */}
                {/* <select style={selectStyle} /> */}
              </TableCell>

              {/* <TableCell sx={cellStyle}>
                <Label text="c. INSURANCE PLAN NAME" />
                <input
                  style={InputStyle}
                  value={SecondarInsuranceName ? SecondarInsuranceName : ""}
                />
                <Label text="d. IS THERE ANOTHER HEALTH BENEFIT PLAN?" />
              </TableCell> */}
            </TableRow>
            <TableRow>
              <TableCell colSpan={2} sx={cellStyle}>
                <div
                  style={{ display: "flex", gap: 6, alignItems: "flex-end" }}
                >
                  {/* React Select – MAX WIDTH */}
                  <div style={{ flex: "1 1 75%", minWidth: 0 }}>
                    <Label text="9d.Secondary Payer Name" />
                    {/* <ReactSelect
                      value={
                        SearchInsurance.find(
                          (opt) => opt.label === SecondarInsuranceName
                        ) || SecondarInsuranceName
                      }
                      placeholder="Search And Select"
                      onChange={(selectedOption) => {
                        setSecondarInsuranceName(selectedOption.label);
                        setSecPayerId(selectedOption.payerId);
                        setsecInsuranceId(selectedOption.value);
                      }}
                      options={SearchInsurance}
                      styles={simpleSelectStyle}
                      menuPortalTarget={document.body}
                    /> */}
                    <AsyncSelect
                      cacheOptions
                      defaultOptions
                      loadOptions={loadInsuranceOptions}
                      // value={SearchInsurance?.find(
                      //   (opt) => opt.label === SecondarInsuranceName
                      // )}
                      // value={SecondarInsuranceName}
                      // value={selectedSecInsurance}
                      value={
                        selectedSecInsurance
                          ? selectedSecInsurance
                          : SecondarInsuranceName
                            ? {
                                label: SecondarInsuranceName,
                                value: secInsuranceId || "",
                              }
                            : null
                      }
                      placeholder="Search And Select"
                      onChange={(selectedOption) => {
                        setselectedSecInsurance(selectedOption);
                        if (selectedOption) {
                          const nameOnly =
                            selectedOption.label.split(" (Payer ID:")[0];
                          setSecondarInsuranceName(nameOnly);
                          setSecPayerId(selectedOption.payerId);
                          setsecInsuranceId(selectedOption.value);
                        } else {
                          setSecondarInsuranceName("");
                          setSecPayerId("");
                          setsecInsuranceId("");
                        }
                      }}
                      isClearable
                      styles={tinySelectStyle}
                      menuPortalTarget={document.body}
                    />
                  </div>

                  {/* Payer ID – MIN WIDTH */}
                  <div style={{ flex: "0 0 80px" }}>
                    <Label text="Payer ID" />
                    <input
                      style={{
                        border: "1px solid #999",
                        padding: "3px",
                        fontSize: 11,
                        height: 30,
                        width: "100%",
                        boxSizing: "border-box",
                      }}
                      value={SecondarInsuranceName ? SecPayerId : ""}
                      readOnly
                    />
                  </div>
                </div>

                <Label text="SECONDARY PAYER CLAIM ID" />
                <input
                  style={InputStyle}
                  value={SecondarInsuranceName ? SecPayerId : ""}
                />
                <Label text="MEDICARE TYPE CODE" />
                <select style={selectStyle} defaultValue="">
                  <option value="" disabled>
                    -- Select --
                  </option>
                </select>
              </TableCell>

              <TableCell colSpan={1} sx={cellStyle}>
                <Label text="9e. SECONDRY PATIENT RELATIONSHIP" />
                {/* <select style={selectStyle}>
                  <option>SELF</option>
                  <option>SPOUSE</option>
                  <option>MOTHER</option>
                </select> */}
                <select
                  style={selectStyle}
                  value={SecRelation || ""}
                  onChange={(e) => setSecRelation(e.target.value)}
                >
                  <option value="">Select</option>
                  <option value="Self">Self</option>
                  <option value="Spouse">Spouse</option>
                  <option value="Mother">Mother</option>
                  <option value="Father">Father</option>
                  <option value="Other">Other</option>
                </select>
                <Label text="9f.SECONDARY PAYER GROUP NAME" />
                <input style={InputStyle} value="" />
                <Label text="9g.SECONDARY PAYER GROUP NUMBER" />
                <input
                  style={InputStyle}
                  value={SecondarInsuranceName ? SecondarMemberid : ""}
                  onChange={(e) => setSecondarMemberid(e.target.value)}
                />

                {/* <Label text="9e. RELATIONSHIP TO PATIENT" />
              <select style={selectStyle} /> */}
              </TableCell>

              {/* <TableCell sx={cellStyle}>
                <Label text=" SUPERVISING PROVIDER NAME" />
                <select
                  style={selectStyle}
                  value={attendingPhysician || ""}
                  onChange={(e) => {
                    const selectedValue = e.target.value;
                    setValue("attendingPhysician", selectedValue);

                    const selectedProvider = providers.find(
                      (p) => String(p.value) === String(selectedValue)
                    );

                    if (selectedProvider) {
                      setNpi(selectedProvider.npi || "");
                      setTaxId(selectedProvider.taxId || "");
                      setbillingProvider(selectedProvider.billingProvider);
                      setProviderAddress(selectedProvider.address);
                      setProviderphone(selectedProvider.phone);
                      setProviderZip(selectedProvider.zipCode);
                      setProviderState(selectedProvider.state);
                    } else {
                      setNpi("");
                      setTaxId("");
                    }

                    setProviderError(false);
                  }}
                >
                  <option value="" disabled>
                    -- Select Provider --
                  </option>

                  {providers.map((p) => (
                    <option key={p.value} value={p.value}>
                      {p.label}
                    </option>
                  ))}
                </select>

               

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    marginTop: "10PX",
                  }}
                >
                  <span
                    style={{
                      fontSize: 8,
                      minWidth: 30, // label fixed width
                      textAlign: "left",
                      fontWeight: "bold",
                    }}
                  >
                    TAX ID
                  </span>

                  <input style={InputStyle} placeholder="ID" value={taxId} />
                  <span
                    style={{
                      fontSize: 8,
                      minWidth: 20, // label fixed width
                      textAlign: "left",
                      fontWeight: "bold",
                    }}
                  >
                    NPI
                  </span>
                  <input style={InputStyle} placeholder="NPI" value={npi} />
                </div>
              </TableCell> */}
            </TableRow>

            <TableRow>
              {/* 12 */}
              <TableCell colSpan={2} sx={cellStyle}>
                <Label text="12. PATIENT'S OR AUTHORIZED PERSON'S SIGNATURE I authorize the release of any medical or other information necessary to process this claim. I also request payment of government benefits either to myself or to the party who accepts assignment below." />

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    marginTop: 6,
                  }}
                >
                  <span style={{ fontSize: 11 }}>SIGNED</span>

                  <input
                    style={{
                      ...InputStyle,
                      flex: 1,
                      fontWeight: 500,
                    }}
                    value="Signature on file"
                    readOnly
                  />

                  <span style={{ fontSize: 11 }}>DATE</span>

                  <input
                    style={{
                      ...InputStyle,
                      width: 120,
                    }}
                    value={createdDate}
                    type="date"
                    readOnly
                  />
                </div>
              </TableCell>

              {/* 13 */}
              <TableCell sx={cellStyle}>
                <Label text="13. INSURED'S OR AUTHORIZED PERSON'S SIGNATURE I authorize payment of medical benefits to the undersigned physician or supplier for services described below." />

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    marginTop: 6,
                  }}
                >
                  <span style={{ fontSize: 11 }}>SIGNED</span>

                  <input
                    style={{
                      ...InputStyle,
                      flex: 1,
                      fontWeight: 500,
                    }}
                    value="Signature on file"
                    readOnly
                  />
                </div>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={cellStyle}>
                <Label text="14. DATE OF CONDITION" />
                <input style={InputStyle} type="date" />
              </TableCell>

              <TableCell sx={cellStyle}>
                <Label text="17. REFERRING PHYSICIAN NAME" />
                <select
                  style={selectStyle}
                  value={referringPhysician || ""}
                  onChange={(e) => {
                    const selectedValue = e.target.value;
                    setValue("referringPhysician", selectedValue);

                    const selected = referringPhysicianList.find(
                      (p) => String(p.value) === String(referringPhysician),
                    );
                    if (selected) {
                      setReferringProviderNpi(selected.npi || "");
                    }
                  }}
                >
                  <option value="" disabled>
                    -- Select Physician --
                  </option>

                  {referringPhysicianList.map((p) => (
                    <option key={p.value} value={p.value}>
                      {p.label}
                    </option>
                  ))}
                </select>

                {/* <Label text="9e. RELATIONSHIP TO PATIENT" />
              <select style={selectStyle} /> */}
              </TableCell>

              <TableCell sx={cellStyle}>
                <Label text="17a. REFERRING PHYSICIAN NPI" />
                <input
                  style={InputStyle}
                  placeholder="ID"
                  value={referringProviderNpi}
                />
              </TableCell>
            </TableRow>

            {/* ================= ROW 8: ADD DATE FIELD ================= */}
            <TableRow>
              <TableCell colSpan={3} sx={cellStyle}>
                <Label text="ADD DATE FIELD" />
                <input style={InputStyle} type="date" />
              </TableCell>
            </TableRow>

            {/* ================= ROW 9: 19. CLAIM NARRATIVE ================= */}
            <TableRow>
              <TableCell colSpan={3} sx={cellStyle}>
                <Label text="19. CLAIM NARRATIVE" />
                <textarea
                  style={{
                    width: "100%",
                    minHeight: "80px",
                    border: "1px solid #ccc",
                    padding: "4px",
                    fontSize: "12px",
                    fontFamily: "inherit",
                  }}
                />
              </TableCell>
            </TableRow>

            {/* ================= ROW 10: 21. DIAGNOSIS & 18. HOSPITALIZATION ================= */}
            <TableRow>
              <TableCell colSpan={2} sx={cellStyle}>
                <Label text="21. DIAGNOSIS OR NATURE OF ILLNESS OR INJURY (Relate to 24E by line)" />
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(4, 1fr)",
                    gap: 4,
                  }}
                >
                  {[
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                  ].map((letter) => (
                    <div
                      key={letter}
                      style={{ display: "flex", alignItems: "center", gap: 4 }}
                    >
                      <span style={{ fontSize: "10px" }}>{letter}.</span>
                      <input
                        style={InputStyle}
                        value={diagnosisCodes[letter]}
                        onChange={(e) =>
                          handleDiagnosisCodeChange(letter, e.target.value)
                        }
                        placeholder={`DX${letter.charCodeAt(0) - 64}`}
                      />
                    </div>
                  ))}
                </div>
              </TableCell>

              <TableCell sx={cellStyle}>
                <Label text="18. HOSPITALIZATION DATES" />
                <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                  <span style={{ fontSize: "11px" }}>FROM</span>
                  <input style={InputStyle} type="date" />
                  <span style={{ fontSize: "11px" }}>TO</span>
                  <input style={InputStyle} type="date" />
                </div>
                 <div style={{ display: "flex", gap: 20, alignItems: "center" }}>
                  <span>
                <Label text="22. RESUBMISSION CODE" />
                </span>
                <span>
                <Label text="(Payer ICN)" /></span>
                </div>
                 <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                 <select
                  style={{ ...InputStyle, }}
                  value={resubmissionCode}
                  onChange={(e) => setResubmissionCode(e.target.value)}
                >
                  <option value="">-- Select --</option>
                  <option value="1">1 - Original Claim</option>
                  <option value="7">7 - Replacement / Corrected Claim</option>
                  <option value="8">8 - Void / Cancel Claim</option>
                </select>
                
                <input   style={{
    ...InputStyle,
    border: isResubmissionSelected && !payerICN ? "1px solid red" : InputStyle.border
  }}
                  value={payerICN}
                  onChange={(e) => setPayerICN(e.target.value)}
                />
                </div>
                <Label text="23. PRIOR AUTHORIZATION NUMBER" />
                <input
                  value={priorAuthorization}
                  onChange={(e) => setPriorAuthorization(e.target.value)}
                  style={InputStyle}
                />
                <Label text="CLA NUMBER" />
                <input style={InputStyle} />
              </TableCell>
            </TableRow>
            {/* ================= ROW 12: 24. SERVICES TABLE HEADER ================= */}
            {/* <TableRow>
            <TableCell colSpan={3} sx={{ ...cellStyle, padding: "4px" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns:
                    "0.8fr 0.5fr 0.5fr 1fr 0.6fr 0.6fr 0.8fr 0.8fr",
                  gap: "2px",
                  fontSize: "10px",
                  fontWeight: "bold",
                }}
              >
                <div> A. DOS</div>
                <div>B. POS</div>
                <div>C. PROCEDURES, SERVICES</div>
                <div>D. DIAGNOSIS</div>
                <div>E. CHARGES</div>
                <div> F. UNITS</div>
                <div>F. $ CHARGES</div>
                <div>G. UNITS</div>
              </div>
            </TableCell>
          </TableRow> */}
            <TableRow>
              <TableCell colSpan={3} sx={{ padding: 0 }}>
                <Table
                  size="small"
                  sx={{
                    tableLayout: "fixed",
                    width: "100%",
                    borderCollapse: "collapse",
                  }}
                >
                  {/* ================= TABLE HEADER ================= */}
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{
                          border: "1px solid #000",
                          textAlign: "center",
                          fontWeight: "bold",
                          fontSize: "10px",
                          padding: "4px",
                          width: "9%",
                        }}
                      >
                        <span>
                          <b>24.{""}</b>
                        </span>{" "}
                        A. DOS
                      </TableCell>
                      <TableCell
                        sx={{
                          border: "1px solid #000",
                          textAlign: "center",
                          fontWeight: "bold",
                          fontSize: "10px",
                          padding: "4px",
                          width: "6%",
                        }}
                      >
                        B. POS
                      </TableCell>
                      <TableCell
                        sx={{
                          border: "1px solid #000",
                          textAlign: "center",
                          fontWeight: "bold",
                          fontSize: "10px",
                          padding: "4px",
                          width: "20%",
                        }}
                      >
                        C. PROCEDURES, SERVICES
                      </TableCell>
                      <TableCell
                        sx={{
                          border: "1px solid #000",
                          textAlign: "center",
                          fontWeight: "bold",
                          fontSize: "10px",
                          padding: "4px",
                          width: "18%",
                        }}
                      >
                        D. DIAGNOSIS
                      </TableCell>
                      <TableCell
                        sx={{
                          border: "1px solid #000",
                          textAlign: "center",
                          fontWeight: "bold",
                          fontSize: "10px",
                          padding: "4px",
                          width: "7%",
                        }}
                      >
                        E. CHARGES
                      </TableCell>
                      {/* <TableCell
                        sx={{
                          border: "1px solid #000",
                          textAlign: "center",
                          fontWeight: "bold",
                          fontSize: "10px",
                          padding: "4px",
                          width: "8%",
                        }}
                      >
                        F. UNITS
                      </TableCell> */}
                      <TableCell
                        sx={{
                          border: "1px solid #000",
                          textAlign: "center",
                          fontWeight: "bold",
                          fontSize: "10px",
                          padding: "4px",
                          width: "14%",
                        }}
                      >
                        F. $ MODIFIERS
                      </TableCell>
                      <TableCell
                        sx={{
                          border: "1px solid #000",
                          textAlign: "center",
                          fontWeight: "bold",
                          fontSize: "10px",
                          padding: "4px",
                          width: "8%",
                        }}
                      >
                        G. UNITS
                      </TableCell>
                      <TableCell
                        sx={{
                          border: "1px solid #000",
                          textAlign: "center",
                          fontWeight: "bold",
                          fontSize: "10px",
                          padding: "4px",
                          width: "11%",
                        }}
                      >
                        H. RENDERING NPI
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  {/* ================= TABLE BODY ================= */}
                  <TableBody>
                    {[0, 1, 2, 3].map((index) => {
                      const rowData = [
                        {
                          dos: dos,
                          pos: code,
                          procedure: code,
                          diagnosis: d,
                          charges,
                          unit: UNIT,
                        },
                        {
                          dos: dos1,
                          pos: code1,
                          procedure: code1,
                          diagnosis: d1,
                          charges: charges1,
                          unit: UNIT1,
                        },
                        {
                          dos: dos2,
                          pos: code2,
                          procedure: code2,
                          diagnosis: d2,
                          charges: charges2,
                          unit: UNIT2,
                        },
                        {
                          dos: dos3,
                          pos: code3,
                          procedure: code3,
                          diagnosis: d3,
                          charges: charges3,
                          unit: UNIT3,
                        },
                      ][index];

                      return (
                        <TableRow key={index}>
                          {/* A. DOS */}
                          <TableCell
                            sx={{ border: "1px solid #000", padding: "2px" }}
                          >
                            <input
                              size="small"
                              type="date"
                         value={rowData.dos}
                              onChange={(e) => {
                                     const val = e.target.value;
                                if (index === 0) setDos(val);
                                else if (index === 1) setDos1(val);
                                else if (index === 2) setDos2(val);
                                else setDos3(val);
                              }}
                              variant="standard"
                              style={{
                                width: "100%",
                                border: "1px solid #999",
                                padding: "3px",
                                fontSize: 11,
                                height: 24,
                                boxSizing: "border-box",
                              }}
                            />
                          </TableCell>

                          {/* B. POS */}
                          <TableCell
                            sx={{ border: "1px solid #000", padding: "2px" }}
                          >
                            <input
                              style={InputStyle}
                              size="small"
                              // value={
                              //   procedureCodeList.find(
                              //     (opt) => opt.value === rowData.pos,
                              //   )?.placeOfService || ""
                              // }
                           value={POS[index] ?? ""}
  onChange={(e) => {
    const updated = [...POS];
    updated[index] = e.target.value;
    setPOS(updated);
  }}
                              variant="standard"
                            />
                          </TableCell>

                          {/* C. PROCEDURES */}
                          <TableCell
                            sx={{ border: "1px solid #000", padding: "2px" }}
                          >
                        {/* <ReactSelect
                            value={getMatchedOption(rowData)}
                            onChange={(selectedOption) => {
                              if (selectedOption) {
                                const code = selectedOption.value;
                                const charges = parseFloat(selectedOption.default_charges);
                                const unit = selectedOption.unit;

                                if (index === 0) {
                                  setCode(code); setCharges(charges); setUNIT(unit); setValue("cpt1", code);
                                } else if (index === 1) {
                                  setCode1(code); setCharges1(charges); setUNIT1(unit); setValue("cpt2", code);
                                } else if (index === 2) {
                                  setCode2(code); setCharges2(charges); setUNIT2(unit); setValue("cpt3", code);
                                } else {
                                  setCode3(code); setCharges3(charges); setUNIT3(unit);
                                }
                              } else {
                                if (index === 0) { setCode(""); setCharges(""); setUNIT(""); setValue("cpt1",""); }
                                else if (index === 1) { setCode1(""); setCharges1(""); setUNIT1(""); setValue("cpt2",""); }
                                else if (index === 2) { setCode2(""); setCharges2(""); setUNIT2(""); setValue("cpt3",""); }
                                else { setCode3(""); setCharges3(""); setUNIT3(""); }
                              }
                            }}
                            options={procedureCodeList}
                            styles={simpleSelectStyle}
                            menuPortalTarget={document.body}
                          /> */}
                     <ReactSelect
  value={
    procedureCodeList.find(
      (opt) =>
        opt.value === rowData.procedure &&
        parseFloat(opt.qasim) === parseFloat(rowData.charges)
    ) || { label: rowData.procedure, value: rowData.procedure }
  }
  onChange={(selectedOption) => {
    if (selectedOption) {
      if (index === 0) { setCode(selectedOption.value); setCharges(selectedOption.qasim); setUNIT(selectedOption.unit); setValue("cpt1", selectedOption.value); }
      else if (index === 1) { setCode1(selectedOption.value); setCharges1(selectedOption.qasim); setUNIT1(selectedOption.unit); setValue("cpt2", selectedOption.value); }
      else if (index === 2) { setCode2(selectedOption.value); setCharges2(selectedOption.qasim); setUNIT2(selectedOption.unit); setValue("cpt3", selectedOption.value); }
      else { setCode3(selectedOption.value); setCharges3(selectedOption.qasim); setUNIT3(selectedOption.unit); }
    }
  }}

  options={procedureCodeList}
 styles={simpleSelectStyle}
/>
                          </TableCell>

                          {/* D. DIAGNOSIS */}
                          <TableCell
                            sx={{ border: "1px solid #000", padding: "2px" }}
                          >
                            <ReactSelect
                              isMulti
                              value={rowData.diagnosis.map((dxCode) => {
                                const option = diagnosisList.find(
                                  (item) =>
                                    String(item.value) === String(dxCode),
                                );
                                return {
                                  label: option ? option.label : dxCode,
                                  value: dxCode,
                                };
                              })}
                              onChange={(selectedOptions) => {
                                const selectedValues = selectedOptions
                                  ? selectedOptions.map((opt) =>
                                      String(opt.value),
                                    )
                                  : [];
                                if (index === 0) setD(selectedValues);
                                else if (index === 1) setD1(selectedValues);
                                else if (index === 2) setD2(selectedValues);
                                else setD3(selectedValues);
                              }}
                              options={diagnosisList}
                              styles={simpleSelectStyle}
                              menuPortalTarget={document.body}
                            />
                          </TableCell>

                          {/* E. CHARGES */}
                          <TableCell
                            sx={{ border: "1px solid #000", padding: "2px" }}
                          >
                            <input
                              style={InputStyle}
                              size="small"
                              value={rowData.charges}
                              onChange={(e) => {
                                if (index === 0) setCharges(e.target.value);
                                else if (index === 1)
                                  setCharges1(e.target.value);
                                else if (index === 2)
                                  setCharges2(e.target.value);
                                else setCharges3(e.target.value);
                              }}
                              variant="standard"
                            />
                          </TableCell>

                          <TableCell
                            sx={{ border: "1px solid #000", padding: "2px" }}
                          >
                            <div style={{ display: "flex", gap: "4px" }}>
                              {[0, 1, 2, 3].map((i) => (
                                <input
                                  key={i}
                                  style={{
                                    ...InputStyle,
                                    // width: "30px",
                                    textAlign: "center",
                                    fontSize: 11,
                                  }}
                                  size="small"
                                  // readOnly
                                  // value={
                                  //   procedureCodeList.find(
                                  //     (opt) =>
                                  //       String(opt.value) ===
                                  //       String(rowData.procedure),
                                  //   )?.[`modifiers${i}`] || ""
                                  // }
                              value={modifiers[index]?.[i] ?? ""}
                                 onChange={(e) => {
  const updated = [...modifiers];

  updated[index] = [...updated[index]];
  updated[index][i] = e.target.value;

  setModifiers(updated);
}}
                                />
                              ))}
                            </div>
                          </TableCell>

                          {/* F. $ CHARGES */}
                          {/* <TableCell
                            sx={{ border: "1px solid #000", padding: "2px" }}
                          >
                            <input
                              style={InputStyle}
                              size="small"
                              value={rowData.charges}
                              variant="standard"
                            />
                          </TableCell> */}

                          {/* G. UNITS */}
                          <TableCell
                            sx={{ border: "1px solid #000", padding: "2px" }}
                          >
                            <input
                              style={InputStyle}
                              size="small"
                              // value={
                              //   procedureCodeList.find(
                              //     (opt) =>
                              //       String(opt.value) ===
                              //       String(rowData.procedure),
                              //   )?.unit || ""
                              // }
                            //  value={getMatchedOption(rowData)?.unit || ""}
                                value={
                                rowData.unit !== undefined && rowData.unit !== null && rowData.unit !== "" && rowData.unit !== "0"
                                  ? rowData.unit
                                  : getMatchedOption(rowData)?.unit || ""
                              }
                              onChange={(e) => {
                                if (index === 0) setUNIT(e.target.value);
                                else if (index === 1) setUNIT1(e.target.value);
                                else if (index === 2) setUNIT2(e.target.value);
                                else setUNIT3(e.target.value);
                              }}
                              variant="standard"
                            />
                          </TableCell>
                          <TableCell
                            sx={{ border: "1px solid #000", padding: "2px" }}
                          >
                            <input
                              style={InputStyle}
                              size="small"
                              value={rowData.procedure ? npi : ""}
                              variant="standard"
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell colSpan={3} sx={{ padding: 0 }}>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr", // 6 columns for your fields
                    border: "1px solid #000", // outer border
                  }}
                >
                  {/* TAX I.D */}
                  <Box
                    sx={{
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                      padding: "4px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "2px",
                    }}
                  >
                    <Typography sx={{ fontSize: 11, fontWeight: "bold" }}>
                      25.TAX I.D
                    </Typography>
                    <input
                      style={InputStyle}
                      size="small"
                      value={taxId}
                      variant="standard"
                    />
                  </Box>

                  {/* PATIENT'S ACCOUNT # */}
                  <Box
                    sx={{
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                      padding: "4px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "2px",
                    }}
                  >
                    <Typography sx={{ fontSize: 11, fontWeight: "bold" }}>
                      26.PATIENT'S ACCOUNT #
                    </Typography>
                    <input
                      style={InputStyle}
                      size="small"
                      value={patientid}
                      variant="standard"
                    />
                  </Box>

                  {/* ACCEPT ASSIGNMENT */}
                  <Box
                    sx={{
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                      padding: "4px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "2px",
                    }}
                  >
                    <Typography sx={{ fontSize: 11, fontWeight: "bold" }}>
                      27.ACCEPT ASSIGNMENT
                    </Typography>
                    <Box sx={{ display: "flex", gap: 2 }}>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <input
                          type="radio"
                          id="acceptYes"
                          checked={acceptAssignment === true}
                          style={{ marginRight: "3px" }}
                          onClick={() => {
                            setValue("acceptAssignment", true);
                            setValue("dontAcceptAssignment", false);
                          }}
                        />
                        <label htmlFor="acceptYes" style={{ fontSize: "11px" }}>
                          YES
                        </label>
                      </Box>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <input
                          type="radio"
                          id="acceptNo"
                          checked={dontAcceptAssignment === true}
                          style={{ marginRight: "3px" }}
                          onClick={() => {
                            setValue("dontAcceptAssignment", true);
                            setValue("acceptAssignment", false);
                          }}
                        />
                        <label htmlFor="acceptNo" style={{ fontSize: "11px" }}>
                          NO
                        </label>
                      </Box>
                    </Box>
                  </Box>

                  {/* TOTAL CHARGES */}
                  <Box
                    sx={{
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                      padding: "4px",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Typography sx={{ fontSize: 11, fontWeight: "bold" }}>
                      28.TOTAL CHARGES
                    </Typography>
                    <input
                      style={InputStyle}
                      size="small"
                      value={`$${totalCharge}`}
                      InputProps={{ readOnly: true }}
                      variant="standard"
                    />
                  </Box>

                  {/* AMOUNT PAID */}
                  <Box
                    sx={{
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                      padding: "4px",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Typography sx={{ fontSize: 11, fontWeight: "bold" }}>
                      29.AMOUNT PAID
                    </Typography>
                    <input
                      style={InputStyle}
                      size="small"
                      value={amountPaid}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9.]/g, "");
                        setAmountPaid(value);
                      }}
                      variant="standard"
                    />
                  </Box>

                  {/* BALANCE DUE */}
                  <Box
                    sx={{
                      borderBottom: "1px solid #000",
                      padding: "4px",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Typography sx={{ fontSize: 11, fontWeight: "bold" }}>
                      30.BALANCE DUE
                    </Typography>
                    <input
                      style={InputStyle}
                      size="small"
                      value={`$${balanceDue}`}
                      InputProps={{ readOnly: true }}
                      variant="standard"
                    />
                  </Box>
                </Box>
              </TableCell>
            </TableRow>
            {/* ================= ROW 16: 31. RENDERING PROVIDER ================= */}
            <TableRow>
              <TableCell sx={cellStyle}>
                <Label text="31. RENDERING PROVIDER (Last, First, Middle)" />
                <select
                  style={selectStyle}
                  value={attendingPhysician || ""}
                  onChange={(e) => {
                    const selectedValue = e.target.value;
                    setValue("attendingPhysician", selectedValue);

                    const selectedProvider = providers.find(
                      (p) => String(p.value) === String(selectedValue),
                    );

                    if (selectedProvider) {
                      setNpi(selectedProvider.npi || "");
                      setTaxId(selectedProvider.taxId || "");
                      setbillingProvider(selectedProvider.billingProvider);
                      setProviderAddress(selectedProvider.address);
                      setProviderphone(selectedProvider.phone);
                      setProviderZip(selectedProvider.zipCode);
                      setProviderState(selectedProvider.state);
                    } else {
                      setNpi("");
                      setTaxId("");
                    }

                    setProviderError(false);
                  }}
                >
                  <option value="" disabled>
                    -- Select Physician --
                  </option>

                  {providers.map((p) => (
                    <option key={p.value} value={p.value}>
                      {p.label}
                    </option>
                  ))}
                </select>

                {/* <Label text="17. SUPERVISING PROVIDER NAME" />
              <Input /> */}

                <Label text="TAX ID" />
                <input style={InputStyle} placeholder="ID" value={taxId} />
                <Label text="NPI" />

                <input style={InputStyle} placeholder="NPI" value={npi} />
              </TableCell>
              <TableCell sx={cellStyle}>
                <Label text="32. SERVICE FACILITY LOCATION INFORMATION" />
                <Label text=" FACILTY" />
                {/* <input style={InputStyle} value={PracticeName} />
                 */}
            <select
  style={selectStyle}
  value={facilityId || ""}
  onChange={(e) => {
    const selectedValue = e.target.value;

    const selectedFacility = Practices.find(
      (p) => String(p.value) === String(selectedValue)
    );

    setfacilityId(selectedValue);
    setPracticeName(selectedFacility?.label || "");
  }}
>
  <option value="" disabled>
    -- Select Facility --
  </option>

  {Practices?.map((p) => (
    <option key={p.value} value={p.value}>
      {p.label}
    </option>
  ))}
</select>
                <Label text="ADRESS LINE 1" />
                <input style={InputStyle} value={PracticeAddress} />
          
                <Label text="City St Zip C" />
                <input
                  style={InputStyle}
                  value={`${PracticeZipcode.city}, ${PracticeZipcode.state}, ${PracticeZipcode.zipCode}`}
                />
                        <Label text="NPI" />
                <input style={InputStyle} value={PracticeNPI} />
              </TableCell>
              <TableCell sx={cellStyle}>
                <Label text="33. BILLING PROVIDER" />
                {/* <div style={{ display: "flex", gap: 12 }}>
                <div style={{ flex: 2 }}>
                  <div style={{ fontSize: "10px" }}>Provider Name</div>
                  <Input  />

                  <div style={{ fontSize: "10px", marginTop: "4px" }}>
                    Address 1
                  </div>
                  <Input  />

                  <div style={{ fontSize: "10px", marginTop: "4px" }}>
                    Address 2
                  </div>
                  <Input />
                </div>

                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: "10px" }}>City St Zip</div>
                  <Input  />
                  <Input style={{ marginTop: "4px" }} />
                  <Input style={{ marginTop: "4px" }} />

                  <div style={{ fontSize: "10px", marginTop: "4px" }}>
                    Phone
                  </div>
                  <Input  />
                </div>

                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: "10px" }}>Taxonomy</div>
                  <Input />

                  <div style={{ fontSize: "10px", marginTop: "8px" }}>
                    MPI / PROV ID / FACIL ID / BILL ID
                  </div>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: 4,
                      marginTop: "4px",
                    }}
                  >
                    <Input placeholder="MPI" />
                    <Input placeholder="PROV ID" />
                    <Input placeholder="FACIL ID" />
                    <Input placeholder="BILL ID" />
                  </div>
                </div>
              </div> */}
                <select
                  style={selectStyle}
                  value={billingProvider ? attendingPhysician : ""}
                  onChange={(e) => {
                    const selectedValue = e.target.value;

                    setValue("attendingPhysician", selectedValue);

                    const selectedProvider = providers.find(
                      (p) => String(p.value) === String(selectedValue),
                    );

                    if (selectedProvider) {
                      setNpi(selectedProvider.npi || "");
                      setTaxId(selectedProvider.taxId || "");
                      setbillingProvider(selectedProvider.billingProvider);
                      setProviderAddress(selectedProvider.address || "");
                      setProviderphone(selectedProvider.phone || "");
                      setProviderZip(selectedProvider.zipCode || "");
                      setProviderState(selectedProvider.state || "");
                    } else {
                      setNpi("");
                      setTaxId("");
                      setProviderAddress("");
                      setProviderphone("");
                      setProviderZip("");
                      setProviderState("");
                    }

                    setProviderError(false);
                  }}
                >
                  <option value="" disabled>
                    -- Select Provider --
                  </option>
                  {providers.map((p) => (
                    <option key={p.value} value={p.value}>
                      {p.label}
                    </option>
                  ))}
                </select>

                {/* Provider Details */}
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 5,
                    marginTop: 2,
                  }}
                >
                  <div style={{ flex: 1, minWidth: 120 }}>
                    <label style={{ fontSize: 8, fontWeight: "bold" }}>
                      TAX ID
                    </label>
                    <input
                      style={InputStyle}
                      placeholder="ID"
                      value={billingProvider ? taxId : ""}
                    />
                  </div>

                  <div style={{ flex: 1, minWidth: 120 }}>
                    <label style={{ fontSize: 8, fontWeight: "bold" }}>
                      NPI
                    </label>
                    <input
                      style={InputStyle}
                      placeholder="NPI"
                      value={billingProvider ? npi : ""}
                    />
                  </div>

                  <div style={{ flex: 1, minWidth: 200 }}>
                    <label style={{ fontSize: 8, fontWeight: "bold" }}>
                      Address
                    </label>
                    <input
                      style={InputStyle}
                      placeholder="Address"
                      value={billingProvider ? ProviderAddress : ""}
                    />
                  </div>

                  <div style={{ flex: 1, minWidth: 80 }}>
                    <label style={{ fontSize: 8, fontWeight: "bold" }}>
                      State
                    </label>
                    <input
                      style={InputStyle}
                      placeholder="State"
                      value={billingProvider ? ProviderState : ""}
                    />
                  </div>

                  <div style={{ flex: 1, minWidth: 100 }}>
                    <label style={{ fontSize: 8, fontWeight: "bold" }}>
                      Zip Code
                    </label>
                    <input
                      style={InputStyle}
                      placeholder="Zip"
                      value={billingProvider ? ProviderZip : ""}
                    />
                  </div>

                  <div style={{ flex: 1, minWidth: 120 }}>
                    <label style={{ fontSize: 8, fontWeight: "bold" }}>
                      Phone
                    </label>
                    <input
                      style={InputStyle}
                      placeholder="Phone"
                      value={billingProvider ? Providerphone : ""}
                    />
                  </div>
                </div>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <Grid
        item
        md={12}
        sm={12}
        xs={12}
        style={{
          padding: "8px",
          display: "flex",
          justifyContent: "flex-end", // Aligns items to the right
          alignItems: "center",
        }}
      >
        <Button
          startIcon={<SendIcon />}
          onClick={handleSubmit(onSubmit)}
          sx={{
            m: 1,
            px: 3,
            height: 42,
            fontSize: "14px",
            fontWeight: 500,
            textTransform: "none",
            borderRadius: 2,
            background: "linear-gradient(135deg, #1976d2, #42a5f5)",
            color: "#fff",
            boxShadow: "0 4px 10px rgba(25,118,210,0.35)",
            "&:hover": {
              background: "linear-gradient(135deg, #1565c0, #1e88e5)",
              boxShadow: "0 6px 14px rgba(25,118,210,0.45)",
            },
          }}
        >
          Submit & Send to Payer
        </Button>

        <Button
          startIcon={<SaveIcon />}
          onClick={handleSubmit(SimpleSubmit)}
          sx={{
            m: 1,
            px: 3,
            height: 42,
            fontSize: "14px",
            fontWeight: 500,
            textTransform: "none",
            borderRadius: 2,
            background: "linear-gradient(135deg, #2e7d32, #66bb6a)",
            color: "#fff",
            boxShadow: "0 4px 10px rgba(46,125,50,0.35)",
            "&:hover": {
              background: "linear-gradient(135deg, #1b5e20, #43a047)",
              boxShadow: "0 6px 14px rgba(46,125,50,0.45)",
            },
          }}
        >
          Save
        </Button>
      </Grid>
    </>
  );
};

export default PreviewClaim;
